import { ClipboardList, FileText } from "lucide-react";
import { ContratoStatsCard } from "./contract-stats-card";
import { ContratoCardSectionProps } from "@/pages/contrato/contrato.types";

export function ContratoCardSection({ expiring, active, completed }: ContratoCardSectionProps) {
  return (
    <div className="flex gap-[32px]">
      <ContratoStatsCard
        icon={FileText}
        title="Contratos Vencendo"
        value={expiring}
        changeText="Próximos 30 dias"
        percentage=""
        chartColor="#7846FF"
        chartData={[]}
      />
      <ContratoStatsCard
        icon={ClipboardList}
        title="Contratos em execução"
        value={active}
        changeText="Ativos no momento"
        percentage=""
        chartColor="#DC8A26"
        chartData={[]}
      />
      <ContratoStatsCard
        icon={ClipboardList}
        title="Contratos concluídos"
        value={completed}
        changeText="Assinados"
        percentage=""
        chartColor="#13D480"
        chartData={[]}
      />
    </div>
  )
}